import { IForm } from 'core-components/classes/models/IForm'
import { get, set } from 'core-components/classes/services/StorageHelper'
import { BaseCrud, IDataProviderFilter } from 'core-components/types'

export const getSavedFilter = <P = IForm, R = string | number>(
  crud: BaseCrud<P, R>,
  sessionFiltersKey: string | undefined
): IDataProviderFilter | undefined => {
  if (!sessionFiltersKey) {
    return undefined
  }
  const savedFilters = get(`_table_filters--${sessionFiltersKey}`)
  try {
    if (savedFilters) {
      const filters: IDataProviderFilter = JSON.parse(savedFilters)
      if (filters.filters && filters.filters.length) {
        return filters
      }
    }
  } catch (e) {}
  return crud.getFilter()
}

export const setSavedFilter = <P = IForm, R = string | number>(
  filter: IDataProviderFilter | undefined,
  sessionFiltersKey: string | undefined
): void => {
  if (sessionFiltersKey && filter) {
    set(`_table_filters--${sessionFiltersKey}`, JSON.stringify(filter))
  }
}
